import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { DailyDropdown } from '../../../Constant';
import { OptionsVisitorChart } from './analyticsData';
import DropdownCommon from '../../Theme/Common/Dropdown';

const BarChart = () => {
  return (
    <Card className='visitor-card'>
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          
          <div className='card-header-right-icon'>
            <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} />
          </div>
        </div>
      </CardHeader>
      <CardBody className='pt-0'>
        <div className='visitors-container'>
          <ReactApexChart height={270} type='bar' options={OptionsVisitorChart.options} series={OptionsVisitorChart.series} />
        </div>
      </CardBody>
    </Card>
  );
};

export default BarChart;
